import {
  LOCATIONS_REQUEST, LOCATIONS_SUCCESS, LOCATIONS_FAILURE,
  LOCATIONS_REQUEST_DATA, LOCATIONS_SUCCESS_DATA, LOCATIONS_FAILURE_DATA
} from "./LocationsActions";

const initialState = {
  list: [],
  data: [],
  error: null,
  isLoading: false
}

export default function locationsReducer(state = initialState, { type, payload } ){
  switch (type) {
    case LOCATIONS_REQUEST:
      return { ...state, isLoading: true }
    case LOCATIONS_SUCCESS:
      return { ...state, list: payload.data, error: null, isLoading: false }
    case LOCATIONS_FAILURE:
      return { ...state, error: payload.error, isLoading: false }

    case LOCATIONS_REQUEST_DATA:
      return { ...state, isLoading: true }
    case LOCATIONS_SUCCESS_DATA:
      return { ...state, data: payload.data, error: null, isLoading: false }
    case LOCATIONS_FAILURE_DATA:
      return { ...state, error: payload.error, isLoading: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/locations/LocationsReducer.js